// static/table_engine_src/format/format_raw.js

export function clearRawDatasets(el) {
  if (!el || !el.dataset) return;
  Object.keys(el.dataset).forEach((k) => {
    if (String(k).toLowerCase().startsWith("raw")) delete el.dataset[k];
  });
}

export function getAnyRawDataset(el) {
  if (!el || !el.dataset) return "";
  if (el.dataset.raw != null) return String(el.dataset.raw);
  const keys = Object.keys(el.dataset);
  const k = keys.find((kk) => String(kk).toLowerCase().startsWith("raw"));
  return k ? String(el.dataset[k]) : "";
}